<template>
  <div>
    <div class="row">
      <div class="col">
        <base-input>
          <a-checkbox
            :value="formData.membershipExpiryConfig.hasMembershipExpiry"
            v-model="formData.membershipExpiryConfig.hasMembershipExpiry"
            :disabled="viewMode"
            @change="resetMembershipExpiryConfig"
          >
            <label class="form-control-label">Membership Expiry</label>
          </a-checkbox>
        </base-input>
      </div>
    </div>

    <div
      class="ml-4"
      style="width: 90%"
      v-if="formData.membershipExpiryConfig.hasMembershipExpiry"
    >
      <div class="row">
        <div class="col-5 mt-1">
          <label class="form-control-label">
            Membership Period
            <a-tooltip placement="right">
              <template slot="title">
                <span
                  >Expires member after the given period by setting member
                  status to inactive.</span
                >
              </template>
              <small>
                <i class="fa fa-info-circle" aria-hidden="true" />
              </small> </a-tooltip
          ></label>
        </div>
        <div class="col">
          <a-input
            v-model="formData.membershipExpiryConfig.membershipPeriod"
            :disabled="viewMode"
            :maxLength="2"
            @input="onMembershipPeriodInput"
          />
          <small class="text-muted">(in months)</small>
          <div
            class="text-danger"
            v-if="$v.formData.membershipExpiryConfig.membershipPeriod.$dirty"
          >
            <div
              class="error"
              v-if="
                !$v.formData.membershipExpiryConfig.membershipPeriod.required
              "
            >
              Field is required
            </div>

            <div
              class="error"
              v-if="
                !$v.formData.membershipExpiryConfig.membershipPeriod.numeric
              "
            >
              Value must be numeric
            </div>

            <div
              class="error"
              v-if="
                !$v.formData.membershipExpiryConfig.membershipPeriod.maxLength
              "
            >
              Maximum of ({{
                $v.formData.membershipExpiryConfig.membershipPeriod.$params
                  .maxLength.max
              }}) character is allowed
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <base-input>
          <a-checkbox
            :value="formData.pointsExpiryConfig.hasPointsExpiry"
            v-model="formData.pointsExpiryConfig.hasPointsExpiry"
            @change="
              () => {
                formData.pointsExpiryConfig.expiryType = 'MEMBER';
                // Reset most of form data
                resetPointsExpiryConfig();
                $v.formData.pointsExpiryConfig.expiryType.$reset();
              }
            "
            :disabled="viewMode"
          >
            <label class="form-control-label">Points Expiry</label>
          </a-checkbox>
        </base-input>
      </div>
    </div>

    <div
      class="ml-4"
      style="width: 90%"
      v-if="formData.pointsExpiryConfig.hasPointsExpiry"
    >
      <div class="row">
        <div class="col-5">
          <label class="form-control-label"
            >Points Duration
            <a-tooltip placement="right">
              <template slot="title">
                <span>Number of months points will be stored. </span>
              </template>
              <small>
                <i class="fa fa-info-circle" aria-hidden="true" />
              </small> </a-tooltip
          ></label>
        </div>

        <div class="col">
          <a-input
            v-model="
              formData.pointsExpiryConfig.memberExpiryConfig.pointsDuration
            "
            :disabled="viewMode"
            :maxLength="2"
            @input="onPointsDurationInput"
          />
          <small class="text-muted">(in months)</small>
          <div
            v-if="
              $v.formData.pointsExpiryConfig.memberExpiryConfig.pointsDuration
                .$dirty
            "
            class="text-danger"
          >
            <div
              class="error"
              v-if="
                !$v.formData.pointsExpiryConfig.memberExpiryConfig
                  .pointsDuration.required
              "
            >
              Field is required
            </div>

            <div
              class="error"
              v-if="
                !$v.formData.pointsExpiryConfig.memberExpiryConfig
                  .pointsDuration.numeric
              "
            >
              Value must be numeric
            </div>

            <div
              class="error"
              v-if="
                !$v.formData.pointsExpiryConfig.memberExpiryConfig
                  .pointsDuration.maxLength
              "
            >
              Maximum of ({{
                $v.formData.pointsExpiryConfig.memberExpiryConfig.pointsDuration
                  .$params.maxLength.max
              }}) character is allowed
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requiredIf, maxLength, numeric } from 'vuelidate/lib/validators';

export default {
  name: 'MembershipProgramExpiryTab',
  props: {
    expiryConfigData: {
      type: Object,
      default: null
    },
    viewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      options: {
        expiryTypes: [{ code: 'MEMBER', name: 'Member' }]
      },

      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      }
    };
  },

  validations: {
    formData: {
      membershipExpiryConfig: {
        membershipPeriod: {
          required: requiredIf(function () {
            return (
              this.formData.membershipExpiryConfig.hasMembershipExpiry == true
            );
          }),
          maxLength: maxLength(2),
          numeric
        }
      },

      pointsExpiryConfig: {
        expiryType: {
          required: requiredIf(function () {
            return this.formData.pointsExpiryConfig.hasPointsExpiry == true;
          })
        },

        // Start of member config validation rules
        memberExpiryConfig: {
          pointsDuration: {
            required: requiredIf(function () {
              return (
                this.formData.pointsExpiryConfig.hasPointsExpiry == true &&
                this.formData.pointsExpiryConfig.expiryType === 'MEMBER'
              );
            }),
            numeric,
            maxLength: maxLength(2)
          }
        }
        // End of member config validation rules
      }
    }
  },

  methods: {
    sanitizeTwoDigitNumeric(value) {
      return String(value == null ? '' : value)
        .replace(/\D/g, '')
        .slice(0, 2);
    },

    onMembershipPeriodInput(event) {
      const value = event && event.target ? event.target.value : '';
      const sanitized = this.sanitizeTwoDigitNumeric(value);
      this.formData.membershipExpiryConfig.membershipPeriod = sanitized;
    },

    onPointsDurationInput(event) {
      const value = event && event.target ? event.target.value : '';
      const sanitized = this.sanitizeTwoDigitNumeric(value);
      this.formData.pointsExpiryConfig.memberExpiryConfig.pointsDuration =
        sanitized;
    },

    initFormData() {
      this.formData = {
        membershipExpiryConfig: {
          hasMembershipExpiry: false,
          membershipPeriod: null
        },
        pointsExpiryConfig: {
          hasPointsExpiry: false,
          expiryType: null,
          memberExpiryConfig: {
            pointsDuration: null
          }
        }
      };
    },

    setFormData(expiryConfigData) {
      if (expiryConfigData !== null) {
        this.formData = { ...this.formData, ...expiryConfigData };
      } else {
        this.initFormData();
      }
    },

    clearForm() {
      this.initFormData();
      this.$v.formData.$reset();
    },

    resetPointsExpiryConfig() {
      this.formData.pointsExpiryConfig.memberExpiryConfig = {
        pointsDuration: null
      };

      // Reset validation checking
      this.$v.formData.pointsExpiryConfig.memberExpiryConfig.$reset();
    },

    resetMembershipExpiryConfig() {
      this.formData.membershipExpiryConfig.membershipPeriod = null;

      this.$v.formData.membershipExpiryConfig.$reset();
    }
  },

  created() {
    this.setFormData(this.expiryConfigData);
  },

  watch: {
    expiryConfigData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>
